import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import IconMenu from "../assets/images/icon-menu.svg";
import IconClose from "../assets/images/close-x.svg";

const MenuContainer = styled.nav`
  position: relative;

  @media (max-width: 576px) {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
  }
`;

const MenuIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 576px) {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 50px;
    height: 50px;

    background-color: #e4da1b;
    border-radius: 50%;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);

    transition: transform 0.15s ease;

    &:active {
      transform: scale(0.92);
    }
  }
`;

const BalloonMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 60px;
  right: 0;
  width: 200px;

  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.25);

  padding: 15px;

  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: ${({ isOpen }) =>
    isOpen ? "translateY(0) scale(1)" : "translateY(-12px) scale(0.95)"};

  pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};

  transition: opacity 0.25s ease, transform 0.25s ease;
`;

const MenuItem = styled(Link)`
  display: block;
  padding: 10px;
  color: #000;
  text-decoration: none;
  font-size: 16px;
  font-weight: 700;
  text-align: center;

  border-radius: 6px;

  opacity: 0;
  animation: fadeIn 0.25s ease forwards;

  &:hover {
    background-color: #f1f1f1;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const MenuMobile: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <MenuContainer>
      <MenuIcon onClick={() => setIsOpen((prev) => !prev)}>
        {!isOpen ? (
          <img src={IconMenu} width="30px" alt="menu" />
        ) : (
          <img src={IconClose} width="30px" alt="close" />
        )}
      </MenuIcon>

      <BalloonMenu isOpen={isOpen}>
        <MenuItem onClick={closeMenu} to="/#section-1">
          Home
        </MenuItem>
        <MenuItem onClick={closeMenu} to="/#section-2">
          Como funciona
        </MenuItem>
        <MenuItem onClick={closeMenu} to="/#section-6">
          Perguntas frequentes
        </MenuItem>
        <MenuItem onClick={closeMenu} to="/#section-7">
          Quanto custa
        </MenuItem>
      </BalloonMenu>
    </MenuContainer>
  );
};

export default MenuMobile;
